// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"610":"ef707de3a075430796ce","678":"a0d80eedf7c5e9cbaff1","883":"872db39bdd40a27b7348","898":"64427e25f777c46b5af5","932":"f907845cbf22e93c76fb"}[chunkId] + ".js";
};